exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-prompt {\n  cursor: pointer !important;\n  height: 32px;\n  border: 1px solid #D7D7DE;\n  border-radius: 6px;\n  width: 100%;\n  /* 占满父容器宽度 */\n  height: 40px;\n  /* 高度32px */\n  display: flex;\n  align-items: center;\n  /* 垂直居中 */\n  justify-content: space-between;\n  /* 左右分布 */\n  padding: 0 8px;\n  /* 内边距 */\n  box-sizing: border-box;\n  /* 可选背景色 */\n}\n.new-prompt .new-prompt-text {\n  flex: 1;\n  white-space: nowrap;\n  /* 单行显示 */\n  overflow: hidden;\n  /* 超出部分隐藏 */\n  text-overflow: ellipsis;\n  /* 超出显示省略号 */\n  margin-right: 8px;\n}\n", ""]);

// exports
